import SimpleDropMenu from './simple-drop-menu';
export default SimpleDropMenu;
